// @ts-nocheck
/**
 * Compact stat tile used by the setup wizard's review/launch grids. `tone` picks the surface chrome
 * (review uses a card with shadow; launch uses a flat bordered tile).
 */
export const VoteRoomStatTile = ({ label, value, color, tone = 'card' }) => {
  const wrapperClass =
    tone === 'flat'
      ? 'border border-gray-100 rounded-md px-3 py-2 bg-gray-50/40'
      : 'bg-white border border-gray-200/80 rounded-lg shadow-[0_1px_3px_rgba(0,0,0,0.04)] p-3';
  return (
    <div className={wrapperClass}>
      <p className="text-xs text-gray-400 font-semibold uppercase tracking-wider">{label}</p>
      <p className={`text-xs font-semibold mt-1 tracking-tight ${color || 'text-gray-900'}`}>{value}</p>
    </div>
  );
};
